"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.assign.js");

var _react = _interopRequireDefault(require("react"));

var _SelectField = _interopRequireDefault(require("material-ui/SelectField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var arrow = require('../../../images/chevron.png');

require('../../../sass/components/shared/SelectFilterWrapper.css');

var _default = function _default(props) {
  var dropdownIconStyle = {
    background: "url('".concat(arrow, "')"),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50%',
    backgroundSize: 14,
    top: '-0.6rem'
  };
  var dropdownLabelStyle = {
    paddingLeft: '1rem',
    lineHeight: '4.4rem',
    height: '4.4rem',
    top: '-0.5rem',
    opacity: '1'
  };
  var dropdownStyle = {
    height: '3.4rem',
    minWidth: '30rem'
  };
  var dropDownMenuProps = {
    menuStyle: {
      width: 'inherit'
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    menuItemStyle: {
      textAlign: 'left'
    }
  };
  return /*#__PURE__*/_react.default.createElement(_SelectField.default, _extends({}, props, {
    autoWidth: true,
    className: props.className || 'wrapper-filters',
    style: dropdownStyle,
    iconStyle: dropdownIconStyle,
    labelStyle: dropdownLabelStyle,
    underlineStyle: {
      display: 'none'
    },
    selectedMenuItemStyle: {
      color: '#3084FF'
    },
    dropDownMenuProps: props.dropDownMenuProps || dropDownMenuProps
  }), props.children);
};

exports.default = _default;